import * as Fetch from '../data/Fetch';

const claimTypeDataId = "DataId";
const setAccountType = 'SET_ACCOUNT';
const setAccountsFetchingType = 'SET_ACCOUNTS_FETCHING';
const setAllAccountsType = 'SET_ALL_ACCOUNTS';
const setAllAccountsPhysiciansType = 'SET_ALL_ACCOUNTS_PHYSICIANS';
const setAuthenticatedType = 'SET_AUTHENTICATED';
const setAuthenticatedPrivacyAcceptedType = 'SET_AUTHENTICATED_PRIVACY_ACCEPTED';
const tokenKey = "algonquin";

const initialState = {
    account: null,
    all: null,
    allPhysicians: null,
    authenticated: false,
    authenticatedAccount: null,
    authenticatedPrivacyAccepted: false,
    authenticatedToken: "",
    fetching: false
};

export const accountRoles = {
    Administrator: 'Administrator',
    Billing: 'Billing',
    Technician: 'Technician',
    Physician: 'Physician',
    StudyManager: 'StudyManager',
    SiteCoordinator: 'SiteCoordinator',
    Qa: 'QA',
    Pm: 'PM',
    Guest: 'Guest'
};

export const emptyAccount = {
    email: "",
    firstName: "",
    id: "",
    lastName: "",
    password: "",
    phoneNumber: "",
    resetPassword: true,
    role: accountRoles.Guest,
    studies: null,
    twoFactorEnabled: false,
    userName: ""
};

export function authenticatedAdministrator(accountsState) {
    const authenticatedAllRoles = authenticatedAllRolesInternal(accountsState);
    if (authenticatedAllRoles &&
        accountsState.authenticatedAccount.role === accountRoles.Administrator || accountRoles.Pm
    ) {
        return true;
    }
    return false;
}

export function authenticatedAllRoles(accountsState) {
    return authenticatedAllRolesInternal(accountsState);
}

function authenticatedAllRolesInternal(accountsState) {
    const authenticatedAccount = accountsState.authenticatedAccount;
    const emailConfirmed = (
        authenticatedAccount != null &&
        authenticatedAccount.emailConfirmed
    );

    if (!accountsState.authenticated ||
        !emailConfirmed) {
        return false;
    }
    return true;
}

export function authenticatedHcsRole(accountsState) {
    const authenticatedAllRoles = authenticatedAllRolesInternal(accountsState);
    const authenticatedAccount = accountsState.authenticatedAccount;
    const hcsRole = (
        authenticatedAccount != null &&
        isHcsRole(authenticatedAccount.role)
    );

    if (authenticatedAllRoles &&
        hcsRole) {
        return true;
    }
    return false;
}

export function authenticatedPrevProps(prevProps, authenticated, fetching, update) {
    if (authenticated &&
        !fetching && (
            prevProps == null ||
            prevProps.accountsState.authenticated !== authenticated || (
                update != null &&
                update
        ))) {
        return true;
    }
    return false;
}

export function checkAuthenticated(authenticated, accountsDispatch) {
    const token = localStorage.getItem(tokenKey);
// console.log(`checkAuthenticated(${authenticated},${accountsDispatch})  token: ${token}`);
    if (token == null) {
        return;
    }

    var tokenIsAuthenticated = false;
    (async () => {
        tokenIsAuthenticated = await accountsDispatch.getIsAuthenticated(token);
    })().then(() => {
        if (tokenIsAuthenticated) {
            if (!authenticated) {
                accountsDispatch.getAuthenticatedAccount(token);
            }
        }
        else {
            accountsDispatch.signOut();
        }
    });
}

function getPrivacyAccepted(token) {
    var privacyAccepted = false;
	if ( ! token ) {
		return privacyAccepted;
	}
    const jwt = parseJwt(token);

    if (jwt && jwt.PrivacyAccept != null &&
        typeof jwt.PrivacyAccept === "string") {
        privacyAccepted = jwt.PrivacyAccept.toLowerCase() === "true";
    }

    return privacyAccepted;
}

export function isHcsRole(role) {
    if (role === accountRoles.Administrator ||
        role === accountRoles.Pm ||
        role === accountRoles.Qa ||
        role === accountRoles.Technician) {
        return true;
    }
    return false;
}

function parseJwt(token) {
	if ( ! token ) {
		return null;
	}
    var base64Url = token.split('.')[1];
	if ( ! base64Url ) {
		return null;
	}
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    var jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));

    return JSON.parse(jsonPayload);
};

export const actionCreators = {
    addAcceptPrivacyPolicy: () => async (dispatch, getState) => {
        const accountsState = getState().accounts;
        if (badState(accountsState, false, dispatch)) {
            return;
        }

        const url = await Fetch.getUrl(`Accounts/AddAcceptPrivacyPolicy`);
        const token = accountsState.authenticatedToken;
        const result = await Fetch.postRequest(url, "", token);
        var data = false;
        if (result.succeeded != null) {
            data = result.succeeded;
        }
        if (data) {
            localStorage.setItem(tokenKey, token);
        }
        dispatch({ type: setAuthenticatedPrivacyAcceptedType, data });
        setFetching(false, dispatch);
    },

    create: (account, siteId, studies) => async (dispatch, getState) => {
        const accountsState = getState().accounts;
        if (badState(accountsState, false, dispatch)) {
            return;
        }

        var url = await Fetch.getUrl("Accounts/CreateAccount");
        var body = JSON.stringify({
            email: account.email,
            firstName: account.firstName,
            lastName: account.lastName,
            password: account.password,
            phoneNumber: account.phoneNumber,
            resetPassword: account.resetPassword,
            role: account.role,
            userName: account.userName,
			enabled: account.enabled,
        });
        const accountId = await Fetch.postRequest(url, body, accountsState.authenticatedToken);

        if (Fetch.validResponse(accountId) && (
            siteId != null ||
            studies != null)) {
            url = await Fetch.getUrl("Accounts/AddUserClaims");
            var claims = [];
            if (siteId != null) {
                claims.push({
                    claimType: claimTypeDataId,
                    claimValue: siteId
                });
            }
            else {
                studies.forEach(study => {
                    claims.push({
                        claimType: claimTypeDataId,
                        claimValue: study.id
                    });
                });
            }
            body = JSON.stringify({
                userClaims: claims,
                userId: accountId
            });
            await Fetch.postRequest(url, body, accountsState.authenticatedToken);
        }

        setFetching(false, dispatch);
    },

    delete: (userName) => async (dispatch, getState) => {
        const accountsState = getState().accounts;
        if (badState(accountsState, false, dispatch)) {
            return;
        }

        const url = await Fetch.getUrl("Accounts/DeleteAccount");
        const body = `"${userName}"`;
        await Fetch.postRequest(url, body, null);
        setFetching(false, dispatch);
    },

    forgotPassword: (email) => async (dispatch, getState) => {
        const accountsState = getState().accounts;
        if (badState(accountsState, false, dispatch)) {
            return;
        }

        const url = await Fetch.getUrl("Accounts/ForgotPassword");
        const body = `"${email}"`;
        await Fetch.postRequest(url, body, null);
        setFetching(false, dispatch);
    },

    getById: (id) => async (dispatch, getState) => {
        const accountsState = getState().accounts;
        if (badState(accountsState, false, dispatch)) {
            return;
        }

        const url = await Fetch.getUrl(`Accounts/GetAccountById?id=${id}`);
        const data = await Fetch.postRequest(url, "", accountsState.authenticatedToken);
        setResponse(data, dispatch, setAccountType);
    },

    getByName: (userName) => async (dispatch, getState) => {
        const accountsState = getState().accounts;
        if (badState(accountsState, false, dispatch)) {
            return;
        }

        const data = await getAccountByNameInternal(userName, accountsState.authenticatedToken);
        setResponse(data, dispatch, setAccountType);
    },

    getAll: () => async (dispatch, getState) => {
        const accountsState = getState().accounts;
// console.log("Accounts::getAll()");
        if (badState(accountsState, false, dispatch)) {
            return;
        }

        const url = await Fetch.getUrl("Accounts/GetAllAccounts");
// console.log(`Accounts::GetAll(${url})`);
        const data = await Fetch.postRequest(url, "", accountsState.authenticatedToken);
        setResponse(data, dispatch, setAllAccountsType);
    },

    getAllPhysicians: () => async (dispatch, getState) => {
        const accountsState = getState().accounts;
        if (badState(accountsState, false, dispatch)) {
            return;
        }

        const url = await Fetch.getUrl("Accounts/GetAllPhysicianAccountsForList");
        const data = await Fetch.postRequest(url, "", accountsState.authenticatedToken);
        setResponse(data, dispatch, setAllAccountsPhysiciansType);
    },

    getAuthenticatedAccount: (token) => async (dispatch, getState) => {
        const accountsState = getState().accounts;
        if (badState(accountsState, false, dispatch)) {
            return;
        }

        const url = await Fetch.getUrl("Accounts/GetAuthenticatedAccount");
// console.log("Accounts::GetAuthenticatedAccount ");
        const account = await Fetch.postRequest(url, "", token);
        const privacyAccepted = getPrivacyAccepted(token);
        setAuthenticated(account, token, privacyAccepted, dispatch);
        setFetching(false, dispatch);
    },

    getIsAuthenticated: (token) => async (dispatch, getState) => {
        const accountsState = getState().accounts;
        if (badState(accountsState, false, dispatch)) {
            return;
        }

// console.log("Accounts::GetIsAuthenticated ");
        const url = await Fetch.getUrl("Accounts/GetIsAuthenticated");
        var authenticated = false;
        const data = await Fetch.getRequest(url, token);
        if (Fetch.validResponse(data)) {
// console.log(`Accounts::GetIsAuthenticated  authenticated = true    data = ${data}`);
            authenticated = data;
		} else {
// console.log(`Accounts::GetIsAuthenticated  authenticated = FALSE   data = ${data}`);
        }
        setFetching(false, dispatch);
        return authenticated;
    },

    getPasswordResetToken: (password) => async (dispatch, getState) => {
        const accountsState = getState().accounts;
        if (badState(accountsState, false, dispatch)) {
            return;
        }

        const url = await Fetch.getUrl("Accounts/GetPasswordResetToken");
        const body = `"${password}"`;
        var token = await Fetch.postRequest(url, body, accountsState.authenticatedToken);
        if (!Fetch.validResponse(token)) {
            token = null;
        }
        setFetching(false, dispatch);
        return token;
    },

    resetPassword: (id, code, newPassword) => async (dispatch, getState) => {
        const accountsState = getState().accounts;
        if (badState(accountsState, false, dispatch)) {
            return;
        }

        const url = await Fetch.getUrl("Accounts/ResetPassword");
        const body = JSON.stringify({
            code: code,
            id: id,
            newPassword: newPassword
        });
        var status = await Fetch.postRequest(url, body, null);
        if (status === "") {
            status = true;
        }
        else {
            status = false;
        }
        setFetching(false, dispatch);
        return status;
    },

    sendConfirmationEmail: (id) => async (dispatch, getState) => {
        const accountsState = getState().accounts;
        if (badState(accountsState, false, dispatch)) {
            return;
        }

        const url = await Fetch.getUrl(`Accounts/SendConfirmationEmail?id=${id}`);
        await Fetch.postRequest(url, "", accountsState.authenticatedToken);
        setFetching(false, dispatch);
    },

    set: (data) => async (dispatch) => {
        dispatch({ type: setAccountType, data });
    },

    signIn: (userName, password, recaptchaResponse, rememberMe) => async (dispatch, getState) => {
        const accountsState = getState().accounts;
        if (badState(accountsState, false, dispatch)) {
			return "Bad State";
        }

        const url = await Fetch.getUrl("Accounts/SignIn");
        const body = JSON.stringify({
            userName: userName,
            password: password,
            recaptchaResponse: recaptchaResponse,
            rememberMe: rememberMe
        });
        const token = await Fetch.postRequest(url, body, null);
        var message = "";
        if (token != null) {
            if (token === "InvalidLogin") {
                message = "Invalid credentials. Please try again.";
            }
            else if (token === "FailedReCaptcha") {
                message = "CAPTCHA error. Please try again.";
            }
            else if (token === "RequiresTwoFactor") {
                message = "Two factor authentication required.";
            }
            else if (token === "IsLockedOut") {
                message = "Account is temporarily locked. Please try again later.";
            }
            else if (token.stack != null) {
                message = "Unable to connect to the server.";
            }
            else if (Fetch.validResponse(token)) {
                const account = await getAccountByNameInternal(userName, token);
                const privacyAccepted = getPrivacyAccepted(token);
                setAuthenticated(account, token, privacyAccepted, dispatch);
            }
        }

        setFetching(false, dispatch);
        return message;
    },

    signOut: () => async (dispatch, getState) => {
        const accountsState = getState().accounts;
        if (badState(accountsState, false, dispatch)) {
            return;
        }

        const url = await Fetch.getUrl("Accounts/SignOut");
        await Fetch.postRequest(url, "", accountsState.authenticatedToken);
        localStorage.removeItem(tokenKey);
        const authenticated = false;
        const account = null;
        const privacyAccepted = false;
        const token = "";
        dispatch({ type: setAuthenticatedType, authenticated, account, token, privacyAccepted });
        setFetching(false, dispatch);
    },

    update: (siteId, studies) => async (dispatch, getState) => {
        const accountsState = getState().accounts;
        if (badState(accountsState, true, dispatch)) {
            return;
        }

        var url = await Fetch.getUrl("Accounts/UpdateAccount");
        const account = accountsState.account;
        var body = JSON.stringify({
            email: account.email,
            firstName: account.firstName,
            id: account.id,
            lastName: account.lastName,
            phoneNumber: account.phoneNumber,
            role: account.role,
			enabled: account.enabled,
        });
        const updated = await Fetch.postRequest(url, body, accountsState.authenticatedToken);

        if (Fetch.validResponse(updated) && (
            siteId != null ||
            studies != null)) {
            url = await Fetch.getUrl("Accounts/RemoveAllAndAddUserClaims");
            var claims = [];
            if (siteId != null) {
                claims.push({
                    claimType: claimTypeDataId,
                    claimValue: siteId
                });
            }
            else {
                studies.forEach(study => {
                    claims.push({
                        claimType: claimTypeDataId,
                        claimValue: study.id
                    });
                });
            }
            body = JSON.stringify({
                userClaims: claims,
                userId: account.id
            });
            await Fetch.postRequest(url, body, accountsState.authenticatedToken);
        }

        setFetching(false, dispatch);
    }
};

function badState(accountsState, checkAccount, dispatch) {
    if (accountsState == null ||
        accountsState.fetching) {
        return true;
    }
    if (checkAccount &&
        accountsState.account == null) {
        return true;
    }

    setFetching(true, dispatch);
    return false;
}

function checkNull(value) {
    return value == null ? "" : value;
}

async function getAccountByNameInternal(userName, token) {
    const url = await Fetch.getUrl("Accounts/GetAccountByName");
    const body = `"${userName}"`;
    return await Fetch.postRequest(url, body, token);
}

function setAuthenticated(account, token, privacyAccepted, dispatch) {
    if (Fetch.validResponse(account)) {
        if (privacyAccepted) {
            localStorage.setItem(tokenKey, token);
        }
        const authenticated = true;
        dispatch({ type: setAuthenticatedType, authenticated, account, token, privacyAccepted });
    }
}

function setFetching(data, dispatch) {
    dispatch({ type: setAccountsFetchingType, data });
}

function setResponse(data, dispatch, type) {
    Fetch.setResponse(data, dispatch, type, setAccountsFetchingType);
}

export const reducer = (state, action) => {
    state = state || initialState;

    if (action.type === setAccountType) {
        const account = action.data;
        if (account != null) {
            account.email = checkNull(account.email);
            account.firstName = checkNull(account.firstName);
            account.lastName = checkNull(account.lastName);
            account.phoneNumber = checkNull(account.phoneNumber);
            account.enabled = checkNull(account.enabled);
            if (account.studies == null) {
                account.studies = [];
            }
            account.userName = checkNull(account.userName);
        }

        return {
            ...state,
            account: account
        };
    }

    if (action.type === setAccountsFetchingType) {
        return {
            ...state,
            fetching: action.data
        };
    }

    if (action.type === setAllAccountsType) {
// console.log("reducer::setAllAccountsType");
        return {
            ...state,
            all: action.data
        };
    }

    if (action.type === setAllAccountsPhysiciansType) {
        return {
            ...state,
            allPhysicians: action.data
        };
    }

    if (action.type === setAuthenticatedType) {
        return {
            ...state,
            authenticated: action.authenticated,
            authenticatedAccount: action.account,
            authenticatedPrivacyAccepted: action.privacyAccepted,
            authenticatedToken: action.token
        };
    }

    if (action.type === setAuthenticatedPrivacyAcceptedType) {
        return {
            ...state,
            authenticatedPrivacyAccepted: action.data
        };
    }

    return state;
};



// WEBPACK FOOTER //
// ./src/store/Accounts.js